<template>
  <div>
    <apexchart width="300" height="270" type="bar" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script>

export default {
  name: 'geo',
  props: {
    parentObj: Object,
    parentDomain: Number,
  },

  data() {
    return {
      percentile: {},

      series: [],
          chartOptions: {

            chart: {
              type: 'bar',
              yaxis: {
                type: 'numeric',
                tickAmount: 6,
                max: 100,
                min: 0,
              },
              toolbar: {
                show: false
              },
            },
            tooltip: {
              enabled: true,
            },
            
            annotations: {
              xaxis: [
                {
                  x: 50,
                  strokeDashArray: 0,
                  borderColor: '#BDBDBD',
                  offsetY: -5,
                  label: {
                    orientation: 'horizontal',
                    borderColor: '#BDBDBD',
                    offsetY: -15,
                    style: {
                      color: '#333',
                      background: '#fff'
                    },
                    text: '50th Percentile'
                    
                  }
                }
              ]
            },
            legend: {
              show: false
            },
            states: {
              active: {
                filter: {
                  type: 'none' /* none, lighten, darken */
                }
              }
            },
            fill: {
              colors: [function({ value}) {
                if (value < 50) {
                    return '#85a1c1'
                } else {
                    return '#274b69'
                }
              }],
              opacity:1,
            },
            plotOptions: {
            bar: {
              borderRadius: 2,
              horizontal: true,
              distributed: true,
              }
            },
            dataLabels: {
              enabled: false
            },
            xaxis: {
              type: 'category',
              categories: [],
            }
          },
        }
  },

  created() {
   this.createVars(this.parentObj, this.parentDomain)
  },

  methods: {
    createVars(data, domain) {
      this.percentile = data.country.domains[this.parentDomain].top_percentile
      let series = []
      let categories = []
      for (const i in this.percentile) {
        if (!isNaN(i)) {
          series.push(this.percentile[i].percentile)
          categories.push(this.percentile[i].iso3)
        }
        
      }
      this.series = [{
        data: series,
        name: 'percentile'
      }]

      this.chartOptions.xaxis = {
              type: 'category',
              categories: categories}
      
      this.chartOptions.tooltip.x = {
        formatter: function(val) {
          let set = data.country.domains[domain].top_percentile
          let item = set.filter(x => x.iso3 == val)
          return item[0].country
        }
      }
      
      this.chartOptions.tooltip = {
      
        custom: function({series, seriesIndex, dataPointIndex, w}) {
          let ending = 'th'
            if (series[seriesIndex][dataPointIndex].toString()[1] == 1) {ending = 'st'}
            else if (series[seriesIndex][dataPointIndex].toString()[1] == 2) {ending = 'nd'}
            else if (series[seriesIndex][dataPointIndex].toString()[1] == 3) {ending = 'rd'}

          let set = data.country.domains[domain].top_percentile
          let val = w.config.xaxis.categories[dataPointIndex]
          let item = set.filter(x => x.iso3 == val)
          return '<v-card class="tooltipA">' +
      '<div class="tooltip-title">' + item[0].country + '</div>' +
      '<div class="tooltip-item">'+ 'percentile: ' + series[seriesIndex][dataPointIndex] + ending + '<br>' +
      'raw: ' + item[0].percent.toFixed(1)+'%' +
      
      '</div>' +
      '</v-card>'
        }
      }
    },

    
  }
}
</script>
<style lang="scss">
.tooltipA {
  min-width: 120px;
  width: 100%;
  height:80px;
  background-color: #FFF;
  opacity: .8;
  
}

.tooltip-title {
  height:30px;
  background-color:#E0E0E0;
  padding:.2em;
  
}

.tooltip-item {
  padding:.2em;
  //height:20px;
}
</style>
